export default __webpack_public_path__ + "static/media/019-snowman.5bb9f096.svg";